module.exports = __webpack_public_path__ + "images/shimo/mindmap-new-98e7196ccd7893b5dd5fac3994179982.png";